// Browser Sentry — error capture only, loaded LAZILY. A static `import * as Sentry`
// puts the whole SDK (~100KB gz) in the critical first-load bundle of every landing
// page, which costs LCP/TBT and Google Ads Quality Score. The dynamic import moves it
// to an async chunk fetched after hydration; errors thrown before it resolves are the
// accepted trade-off. No-ops entirely (no download) when the DSN is unset.
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

// VERCEL is not exposed to the browser bundle, so gate on hostname instead: local
// dev/E2E/Lighthouse all run on localhost and must not report (they polluted the real
// project with events tagged "production"). NEXT_PUBLIC_VERCEL_ENV would be cleaner but
// depends on the project's expose-system-envs setting — if that were ever off, prod
// client reporting would silently die; a hostname gate can only fail toward noise.
const isLocalhost = /^(localhost|127\.)/.test(window.location.hostname);

type SentryClient = typeof import("@sentry/nextjs");
let sentry: SentryClient | undefined;

if (dsn && !isLocalhost) {
  void import("@sentry/nextjs").then((mod) => {
    mod.init({
      dsn,
      environment: process.env.VERCEL_ENV ?? process.env.NODE_ENV,
      tracesSampleRate: 0.1,
      // Benign RSC stream abort: the visitor navigated away / closed the tab while
      // the page was still streaming. Recurs with real traffic; never actionable.
      // "Java object is gone": the Facebook Android in-app browser's own injected
      // script (app://navigation_performance_logger_android) calling its native
      // bridge on unload after the WebView tore it down. Not our code; Meta traffic.
      ignoreErrors: ["Connection closed.", "Java object is gone"],
    });
    sentry = mod;
  });
}

export function onRouterTransitionStart(href: string, navigationType: string): void {
  sentry?.captureRouterTransitionStart(href, navigationType);
}
